import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../../core/services/web-storage';
import { ProdutividadeFilter } from '../../adapters';

/**
 * Service utilizado para armazenar os dados do filter dos KPIs de produtividade no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class ProdutividadeFilterStorageService {
    private key = 'produtividadeKPIsFilter';

    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem os dados do filtro armazenados */
    get(): ProdutividadeFilter {
        const data = this.sessionStorageService.get(this.key);
        return data ? ProdutividadeFilter.fromJSON(data) : new ProdutividadeFilter(null);
    }

    /** Armazena os dados do filtro */
    set(filter: ProdutividadeFilter) {
        this.sessionStorageService.setObject(this.key, filter);
    }

    /** Remove os dados do filtro */
    remove() {
        this.sessionStorageService.remove(this.key);
    }
}
